import { render } from "./CadastrarImgBlog.vue?vue&type=template&id=3a589434&scoped=true"
import script from "./CadastrarImgBlog.vue?vue&type=script&lang=js"
export * from "./CadastrarImgBlog.vue?vue&type=script&lang=js"

import "./CadastrarImgBlog.vue?vue&type=style&index=0&id=3a589434&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a589434"]])

export default __exports__